export class MicroQueue<T, R = T> {
  private queue: T[] = [];
  private scheduled = false;

  constructor(
    private readonly onFlush: (items: R[]) => void,
    private readonly strategy: BatchStrategy<T, R>,
    private readonly schedule: ScheduleFn = microtaskScheduler,
  ) {}

  push(item: T) {
    this.queue.push(item);
    this.scheduleFlush();
  }

  pushMany(items: T[]) {
    if (!items.length) return;
    this.queue.push(...items);
    this.scheduleFlush();
  }

  private scheduleFlush() {
    if (this.scheduled) return;

    this.scheduled = true;
    this.schedule(this.flush);
  }

  private flush = () => {
    const items = this.queue;
    this.queue = [];
    this.scheduled = false;

    if (!items.length) return;

    const result = this.strategy.aggregate(items);
    if (result.length) {
      this.onFlush(result);
    }
  };
}

export const microtaskScheduler: ScheduleFn = (cb) => {
  queueMicrotask(cb);
};

export const timeoutScheduler =
  (delay = 0): ScheduleFn =>
  (cb) => {
    setTimeout(cb, delay);
  };

type ScheduleFn = (cb: () => void) => void;

interface BatchStrategy<T, R = T> {
  aggregate(items: T[]): R[];
}
